export enum PathAPI {
  allRaffles = '/bff/customer/home',

  finishedRaffles = '/bff/customer/finished-raffles',

  customerBalance = '/bff/customer/balance',
  purchase = '/carts/purchase',
  walletHistory = '/bff/customer/balance/history',
  customerInfo = '/balance/customer',
  winnersFeed = '/bff/customer/winners-feed',
  customers = '/customers',
  customersGuest = '/customers/guest',
  customersGuestByCustomerId = '/customers/guest-by-customer-id',
  customersGuestStatus = '/customers/guest-status',
  validateCustomerPhone = '/customers/validateCustomerPhone',
  registerCustomer = '/customers/registerCustomer',
  recoverPhone = '/customers/recover-phone',
  exatoValidation = '/bff/customer/balance/exato/validate-doc',
  exatoWebhook = '/bff/customer/webhook/exato',

  ticketsByCartRaffle = '/bff/customer/tickets-by-cart-raffle',

  purchasedRaffles = '/bff/customer/purchased-raffles',

  setScratched = '/raffles/raffle-ticket/set-scratched',
  purchasedRaffle = '/bff/customer/purchased-raffle',
  ticketsByRaffle = '/bff/customer/tickets-by-raffle',
  allFaqs = '/faq',
  allSystemParameters = '/system-parameters/public',
  whitelabelConfig = '/bff/customer/whitelabel-config',
  communicationBanner = '/bff/customer/banners',
  highlightedRaffleDetails = '/bff/customer/raffle-details',
  luckyTicketsByRaffle = '/bff/customer/lucky-tickets-by-raffle',
  raffleOffers = '/bff/customer/raffle-offers',
  ticketDetails = '/bff/customer/ticket-details',
  withdrawAddress = '/bff/customer/balance/update-address',
  withdrawPixKey = '/bff/customer/balance/update-pixkey',
  withdrawRequest = '/bff/customer/balance/withdraw',
  downloadTicket = '/bff/customer/receipt',
  requestOtp = '/bff/customer/request-otp',
  requestPhoneOtp = '/bff/customer/request-phone-otp',
  editProfile = '/bff/customer/balance/user/phone',
  wasPaid = '/carts/public/{id}/was-paid',
  lastValidation = '/bff/customer/validation/last',
  winnerVideos = '/bff/customer/winner-videos',
  trackingEvent = '/tracking/event',
}
